<!-- Validation Warning Modal -->
<div
   *ngIf="showValidationModal"
   class="csv-custom-modal modal-dialog-centered">
   <div
      class="csv-modal-content"
      style="width: 450px">
      <h2>Price Change Warning</h2>
      <p>{{ validationMessage }}</p>
      <p>Please undo the change if this was not intended.</p>
      <button
         mat-button
         (click)="showValidationModal = false"
         class="btn btn-primary"
         style="font-size: 13px; font-weight: 600; margin-top: 12px">
         OK
      </button>
   </div>
</div>
